export const MuiDrawer = {
  styleOverrides: {
    root: {
      '.MuiPaper-root': {
        borderRadius: '0.5rem 0.5rem 0px 0px',
      },
    },
  },
};
